import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=1352aa7a&scoped=true&"
import script from "./Categorias.ts?vue&type=script&lang=ts&"
export * from "./Categorias.ts?vue&type=script&lang=ts&"
import style0 from "./categorias.scss?vue&type=style&index=0&id=1352aa7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352aa7a",
  null
  
)

export default component.exports